// extracted by mini-css-extract-plugin
export default {"modal":"ComparisonSheetScreen_modal__ZnKTC","outlet-container":"ComparisonSheetScreen_outlet-container__peBse"};